import { createReducer } from 'deox'
import {
  setPoolDetail,
  setTotalSoldPool,
  setBchDecimals,
  setIsPoolSoldOut,
} from './actions'
import { IPool, PoolStatusType } from '../../types/reducerTypes'
import Big from 'big.js'

export const initialState: IPool = {
  id: 0,
  airDrop: new Big(0),
  escrowBlock: {},
  totalSaleSupply: new Big(0),
  thresholdPublicAmount: new Big(0),
  token: '',
  createToken: false,
  name: '',
  initialAddress: '',
  poolAddress: '0x1234',
  ticker: '',
  sold: {
    total: new Big(0),
    private: new Big(0),
    public: new Big(0),
  },
  decimals: '18',
  publicThreshold: new Big(0),
  escrow: 0,
  status: PoolStatusType.INCOMING,
  escrowMilestones: [],
  privateSale: {
    price: '0',
    start: '',
    end: '',
    cap: [],
  },
  publicSale: {
    price: '0',
    start: '',
    end: '',
    cap: [],
  },
  blacklist: [],
  about: {
    logo: {
      url: '',
    },
    description: '',
    links: [],
  },
  team: [],
  isPoolSoldOut: false,
  vestingPoints: [],
}

const accessReducer = createReducer(initialState, (handleAction) => [
  handleAction(setPoolDetail, (state, { payload }) => ({
    ...state,
    ...payload,
  })),
  handleAction(setTotalSoldPool, (state, { payload }) => ({
    ...state,
    sold: payload,
  })),
  handleAction(setIsPoolSoldOut, (state, { payload }) => ({
    ...state,
    isPoolSoldOut: payload,
  })),
  handleAction(setBchDecimals, (state, { payload }) => ({
    ...state,
    decimals: payload,
  })),
])

export default accessReducer
